import BaseModel from "./BaseModel";

/**
 * SupportTicketReply
 */
export default class SupportTicketReply extends BaseModel {
  constructor({
    id,
    uuid,
    message,
    user,
    user_name,
    user_email,
    is_admin,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.uuid = uuid || null;
    this.message = message || null;
    this.user = user || null;
    this.user_name = user_name || null;
    this.user_email = user_email || null;
    this.is_admin = is_admin || false;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
  }

  /**
   * Returns true if reply was written by an admin
   * @returns {Boolean}
   */
  isFromAdmin() {
    return !!this.is_admin;
  }

  /**
   * Returns formatted created_at
   * @returns {String}
   */
  getCreatedAtDate() {
    if (!this.created_at) return '-';
    return new Date(this.created_at).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Returns initials for avatar
   * @returns {String}
   */
  getInitials() {
    if (!this.user_name) return '?';
    return this.user_name
      .split(' ')
      .slice(0, 2)
      .map(w => w[0])
      .join('')
      .toUpperCase();
  }
}